import React from 'react';
import styled from 'styled-components';
import { Grid } from '../../../app/StyleGuide';
import { AgeCategory, BrandCode } from '../../curriculum';
import windowService from '../../../services/windowService';

type BannerByAgeCategory = Partial<Record<AgeCategory, { src: string; url: string }>>;
type BrandBanners = Partial<Record<BrandCode, BannerByAgeCategory>>;

const banners: BrandBanners = {
  BSFL: {
    Preschool: {
      src: 'img/AtHome_BSFL.png',
      url: '/catalog/compilation/acc2ff97-0b89-4e90-e89e-fa2fe214792a',
    },
    Kids: {
      src: 'img/AtHome_BSFL.png',
      url: '/catalog/compilation/acc2ff97-0b89-4e90-e89e-fa2fe214792a',
    },
  },
  ETB: {
    Preschool: {
      src: 'img/AtHome_ETB.png',
      url: '/catalog/compilation/97c2caa9-6c2a-48ac-efdc-633e7fd3dd87',
    },
    Kids: {
      src: 'img/AtHome_ETB.png',
      url: '/catalog/compilation/97c2caa9-6c2a-48ac-efdc-633e7fd3dd87',
    },
  },
  TGP: {
    Preschool: {
      src: 'img/AtHome_TGP.png',
      url: '/catalog/compilation/5fb9683c-987e-4d4f-a3e6-a26549a0e0c7',
    },
    Kids: {
      src: 'img/AtHome_TGP.png',
      url: '/catalog/compilation/5fb9683c-987e-4d4f-a3e6-a26549a0e0c7',
    },
  },
  HYFI: {
    Preschool: {
      src: 'img/AtHome_HYFI.jpg',
      url: '/catalog/compilation/80a4b2c4-f549-4d45-c5c5-02c6fba76f3b',
    },
    Kids: {
      src: 'img/AtHome_HYFI.jpg',
      url: '/catalog/compilation/80a4b2c4-f549-4d45-c5c5-02c6fba76f3b',
    },
  },
};

const Banner = styled.div`
  display: flex;
  justify-content: center;
  padding: ${Grid._4} 0 ${Grid._8} 0;

  img {
    cursor: pointer;
    width: auto;
    max-width: 100%;
  }
`;

type AtHomeBannerProps = {
  brandCode: BrandCode;
  ageCategory: AgeCategory;
  brandName?: string;
};

export const AtHomeBanner = ({ brandCode, ageCategory, brandName = '' }: AtHomeBannerProps) => {
  if (!brandCode || !ageCategory) return null;
  if (!banners[brandCode] || !banners[brandCode]?.[ageCategory]) return null;

  const banner = banners[brandCode]?.[ageCategory];
  if (!banner) return null;

  return (
    <Banner>
      <img src={banner.src} alt={`${brandName} at home`} onClick={() => windowService.redirectTo(banner.url)} />
    </Banner>
  );
};
